import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TasksOverview from './Tasks/TasksOverview';
import TaskBoard from './Tasks/TaskBoard';
import TaskCalendar from './Tasks/TaskCalendar';
import CompletedTasks from './Tasks/CompletedTasks';

const Workspace = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="/workspace/table" replace />} />
      <Route path="table" element={<TasksOverview />} />
      <Route path="board" element={<TaskBoard />} />
      <Route path="calendar" element={<TaskCalendar />} />
      <Route path="completed" element={<CompletedTasks />} />
      <Route path="*" element={<Navigate to="/workspace/table" replace />} />
    </Routes>
  );
};

export default Workspace;
